(() => {
  if (window.smChatGPTSignupAttribution) return;
  window.smChatGPTSignupAttribution = true;
  const key = 'sm_chatgpt_paid_signup_v1';
  const ttl = 30 * 24 * 60 * 60 * 1000;
  const markers = {
    first_contact_pilot: 'SM_CHATGPT_PAID_FIRST_CONTACT_V1',
    soundmorph_catalog: 'SM_CHATGPT_PAID_CATALOG_V1'
  };
  const fieldName = 'customer[note][SM paid acquisition]';
  let attribution = null;
  const permitted = () => {
    const privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !!(privacy && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed());
  };
  const valid = value => value && Object.hasOwn(markers, value.campaign) &&
    Number.isFinite(value.at) && value.at <= Date.now() && Date.now() - value.at < ttl;
  const forms = () => Array.from(document.forms).filter(form =>
    form.querySelector('input[name="form_type"][value="create_customer"]'));
  const populate = form => {
    let input = form.querySelector('[data-sm-paid-signup]');
    if (!permitted() || !valid(attribution)) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = fieldName;
      input.dataset.smPaidSignup = 'true';
      form.appendChild(input);
    }
    input.value = markers[attribution.campaign];
  };
  const refresh = () => {
    if (!permitted()) {
      attribution = null;
      try { localStorage.removeItem(key); } catch (_) {}
      forms().forEach(populate);
      return;
    }
    try {
      const stored = JSON.parse(localStorage.getItem(key));
      attribution = valid(stored) ? stored : null;
    } catch (_) {}
    const params = new URLSearchParams(location.search);
    const campaign = params.get('utm_campaign');
    if (!valid(attribution) && params.get('utm_source') === 'chatgpt' &&
        params.get('utm_medium') === 'paid' && Object.hasOwn(markers, campaign)) {
      attribution = {campaign, at: Date.now()};
      try { localStorage.setItem(key, JSON.stringify(attribution)); } catch (_) {}
    }
    forms().forEach(populate);
  };
  document.addEventListener('submit', event => {
    if (event.target instanceof HTMLFormElement &&
        event.target.querySelector('input[name="form_type"][value="create_customer"]')) {
      refresh();
      populate(event.target);
    }
  }, true);
  document.addEventListener('formdata', event => {
    if (event.target instanceof HTMLFormElement &&
        event.target.querySelector('input[name="form_type"][value="create_customer"]')) {
      if (permitted() && valid(attribution)) event.formData.set(fieldName, markers[attribution.campaign]);
      else event.formData.delete(fieldName);
    }
  }, true);
  document.addEventListener('visitorConsentCollected', refresh);
  document.addEventListener('shopify:section:load', refresh);
  const start = () => {
    if (window.Shopify && window.Shopify.customerPrivacy) refresh();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}], error => {
        if (!error) refresh();
      });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();